import React, { useEffect } from 'react';
import { Container, NavDropdown, Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faSignOutAlt, faBell, faSearch, faBars } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import { logoutUser, getProfile } from '../../redux/actions/authActions';

const NavbarComponent = ({ auth, logoutUser, getProfile, onToggleSidebar }) => {
  useEffect(() => {
    if (auth.isAuthenticated) {
      getProfile();
    }
  }, [auth.isAuthenticated, getProfile]);

  return (
    <nav className="navbar navbar-expand-lg navbar-light layout-header">
      <Container fluid>
        <Button
          variant="link"
          className="sidebar-toggle-btn d-lg-none me-2"
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar"
        >
          <FontAwesomeIcon icon={faBars} />
        </Button>
        <div className="navbar-nav-right d-flex align-items-center">
          <div className="navbar-nav align-items-center d-none d-md-flex">
            <div className="nav-item">
              <div className="search-input-wrapper">
                <FontAwesomeIcon icon={faSearch} className="search-icon" />
                <Form.Control
                  type="text"
                  placeholder="Search..."
                  aria-label="Search..."
                />
              </div>
            </div>
          </div>

          <div className="navbar-nav flex-row align-items-center ms-auto">
            <NavDropdown
              align="end"
              title={
                <span>
                  <FontAwesomeIcon icon={faBell} className="bx bx-bell fs-4 lh-0 me-2" />
                </span>
              }
              id="notification-nav-dropdown"
            >
              <NavDropdown.Item href="#notifications">Notifications</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              align="end"
              title={
                <span className="d-flex align-items-center user-dropdown-title">
                  {auth.user?.avatar ? (
                    <img
                      src={auth.user.avatar}
                      alt={auth.user.name}
                      className="rounded-circle me-2"
                      style={{ width: '32px', height: '32px' }}
                    />
                  ) : (
                    <div className="avatar-placeholder me-2">
                      <FontAwesomeIcon icon={faUser} className="fs-4" />
                    </div>
                  )}
                  <span className="user-name">{auth.user?.name || 'User'}</span>
                </span>
              }
              id="profile-nav-dropdown"
            >
              <NavDropdown.Item href="#profile">
                <div className="d-flex align-items-center">
                  {auth.user?.avatar ? (
                    <img
                      src={auth.user.avatar}
                      alt={auth.user.name}
                      className="rounded-circle me-2"
                      style={{ width: '24px', height: '24px' }}
                    />
                  ) : (
                    <div className="avatar-placeholder me-2">
                      <FontAwesomeIcon icon={faUser} className="fs-5" />
                    </div>
                  )}
                  <div className="user-info">
                    <div className="fw-bold text-truncate">{auth.user?.name}</div>
                    <div className="small text-muted text-truncate">{auth.user?.email}</div>
                  </div>
                </div>
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={logoutUser}>
                <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
                Logout
              </NavDropdown.Item>
            </NavDropdown>
          </div>
        </div>
      </Container>
    </nav>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth
});

export default connect(mapStateToProps, { logoutUser, getProfile })(NavbarComponent); 